/**
 * Spacing tokens as MUI multipliers (base unit: 8px)
 * Use these tokens with MUI's sx prop and theme.spacing()
 *
 * Values are multipliers, not pixels:
 * - spacing.sm (1) = 8px
 * - spacing.md (2) = 16px
 * - spacing.lg (3) = 24px
 * - spacing.xl (4) = 32px
 */

// Base unit for MUI spacing system
export const SPACING_BASE_UNIT = 8 // 8px

export const spacing = {
  none: 0,      // 0px
  xs: 0.5,      // 4px
  sm: 1,        // 8px
  input: 1.75,  // 14px - special case for input/button default padding
  md: 2,        // 16px
  lg: 3,        // 24px
  xl: 4,        // 32px
  '2xl': 5,     // 40px
  '3xl': 6,     // 48px
  '4xl': 7,     // 56px
  '5xl': 8,     // 64px
} as const

export type TSpacing = keyof typeof spacing
